"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _NavigationLink = _interopRequireDefault(require("../NavigationLink"));
var _hooks = require("../../../hooks");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * This component is used internally to display menus inside the Navigation component.
 */
const NavigationMenu = _ref => {
  let {
    alignRight,
    generateLink,
    items,
    label,
    ...props
  } = _ref;
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const closeMenu = (0, _react.useCallback)(() => setIsOpen(false), [setIsOpen]);
  const menuRef = (0, _react.useRef)(null);
  (0, _hooks.useOnClickOutside)(menuRef, closeMenu);
  const menuId = (0, _react.useId)();
  return /*#__PURE__*/_react.default.createElement("li", _extends({}, props, {
    className: (0, _classnames.default)(props.className, "p-navigation__item--dropdown-toggle", {
      "is-active": isOpen
    }),
    ref: menuRef
  }), /*#__PURE__*/_react.default.createElement("button", {
    "aria-controls": menuId,
    className: "p-navigation__link u-no-margin--right",
    onClick: evt => {
      evt.preventDefault();
      setIsOpen(!isOpen);
    }
  }, label), /*#__PURE__*/_react.default.createElement("ul", {
    "aria-hidden": !isOpen,
    className: (0, _classnames.default)("p-navigation__dropdown", {
      "p-navigation__dropdown--right": alignRight
    }),
    id: menuId
  }, items.map((item, i) => /*#__PURE__*/_react.default.createElement("li", {
    key: i
  }, /*#__PURE__*/_react.default.createElement(_NavigationLink.default, {
    generateLink: generateLink,
    link: {
      ...item,
      className: (0, _classnames.default)("p-navigation__dropdown-item", item.className)
    }
  })))));
};
var _default = exports.default = NavigationMenu;